export interface MinuteRange {
  startMinutes: number;
  endMinutes: number;
}

export function normalizeMinuteRange(startMinutes: number, endMinutes: number): MinuteRange {
  return {
    startMinutes: Math.min(startMinutes, endMinutes),
    endMinutes: Math.max(startMinutes, endMinutes),
  };
}

export function minuteRangeDuration(range: MinuteRange): number {
  return range.endMinutes - range.startMinutes;
}

export function snapMinutesToIncrement(minutes: number, incrementMinutes: number): number {
  if (incrementMinutes <= 0) {
    throw new Error('incrementMinutes must be greater than 0');
  }

  return Math.round(minutes / incrementMinutes) * incrementMinutes;
}

export function clampMinutes(minutes: number, minMinutes: number, maxMinutes: number): number {
  return Math.max(minMinutes, Math.min(maxMinutes, minutes));
}

export function rangesOverlap(left: MinuteRange, right: MinuteRange): boolean {
  return left.startMinutes < right.endMinutes && right.startMinutes < left.endMinutes;
}

export function rangeOverlapsAny(range: MinuteRange, ranges: MinuteRange[]): boolean {
  return ranges.some((other) => rangesOverlap(range, other));
}

